<template>

    <m-edit1/>

    <m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-chat-widget-1 v-bind='{...{"enableAnimation":false,"defaultCategory":null,"default_show_list":true},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-chat-widget-1><m-div v-bind='{...{},...{}}' :style='""' class="shadow container-fluid " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row text-center py-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 col-sm-6 text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.ahmadsabri.ir\/storage\/icons\/\u0635\u0628\u0631\u06cc_\u062f\u0627\u06cc\u0631\u0647_\u0637\u0644\u0627\u06cc\u06cc (1).jpg","alt":"ahmadsabri"},...{}}' :style='"width:200px "' class="img-fluid" ></m-img><m-h4 v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>احمد صبري   </template>
                </m-h4><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>ملحن ومطرب أهوازي   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 col-sm-6 text-center" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/www.instagram.com\/ahmad.sabri1","target":"_self"},...{}}' :style='""' class="col-12 text-center d-block" >
                <template #default>   <m-span v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>https://www.instagram.com/ahmad.sabri1   </template>
                </m-span><m-img v-bind='{...{"src":"https:\/\/api.ahmadsabri.ir\/storage\/contents\/instagram_240px.png","alt":""},...{}}' :style='"height:50px;"' class="" ></m-img></template>
                </m-a><m-a v-bind='{...{"href":"https:\/\/t.me\/ahmad_sabri10","target":"_self"},...{}}' :style='""' class="col-12 text-center " >
                <template #default>   <m-span v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>https://t.me/ahmad_sabri10   </template>
                </m-span><m-img v-bind='{...{"src":"https:\/\/api.ahmadsabri.ir\/storage\/icons\/-logo-telegram.png","alt":""},...{}}' :style='"height:43px;"' class="" ></m-img></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-hr v-bind='{...{},...{}}' :style='""' class="" ></m-hr></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-6 text-dark" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/mixitweb.com","target":"_self"},...{}}' :style='""' class="text-dark" >
                <template #default>صُنع باستخدام ❤ بواسطة mixitweb   </template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-6" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="text-dark" >
                <template #default>جميع الحقوق محفوظة لأحمد صبري.   </template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mChatWidget1 from '@moeinmdn/miw-alpha-components/src/package/Chat/Widget/ChatWidget1'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mSpan from '@moeinmdn/miw-alpha-components/src/package/Tags/Span'; import mHr from '@moeinmdn/miw-alpha-components/src/package/Tags/Hr';

export default {
    name: 'HomeView',
    components: {mEdit1, mLoading3,mUpdateSiteMessage1,mChatWidget1,mDiv,mImg,mH4,mP,mA,mSpan,mHr },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
